import styled from 'styled-components';
import { colors, typography, spacing, borderRadius } from '../../styles/theme';

export const Callout = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${spacing.md};
  background: rgba(217, 125, 43, 0.08);
  border-left: 4px solid ${colors.primary.orange};
  border-radius: ${borderRadius.lg};
  padding: ${spacing.md} ${spacing.lg};
  margin: ${spacing.lg} 0;

  svg {
    font-size: 1.3rem;
    color: ${colors.primary.orange};
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

export const CalloutTitle = styled.h4`
  font-size: ${typography.fontSize.sm};
  font-weight: ${typography.fontWeight.bold};
  color: ${colors.primary.orange};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 2px 0;
`;

export const CalloutText = styled.p`
  font-size: ${typography.fontSize.base};
  color: ${colors.neutral.gray700};
  line-height: ${typography.lineHeight.relaxed};
  margin: 0;
`;
